<script>
import AppButton from '@/components/ui/AppButton.vue'

export default {
	name: 'ProfileMenu',
	emits: ['select'],
	components: {
		AppButton
	},
	props: {
		activeItem: {
			type: String,
			default: 'data'
		}
	},
	computed: {
		items() {
			return [
				{ id: 'data', label: this.$t('myArea.menu.data'), icon: 'profileData', available: true },
				{ id: 'security', label: this.$t('myArea.menu.security'), icon: 'profileSecurity', available: true },
				{ id: 'products', label: this.$t('myArea.menu.products'), icon: 'profileProducts', available: true },
				{ id: 'referrals', label: this.$t('myArea.menu.referrals'), icon: 'profileReferrals', available: true },
				// { id: 'points', label: this.$t('myArea.menu.points'), icon: 'profilePoints', available: false }
			]
		}
	},
	watch: {
		activeItem() {
			this.scrollActiveItemIntoView()
		}
	},
	mounted() {
		this.scrollActiveItemIntoView(false)
	},
	methods: {
		getAccessibilityLabel(item) {
			return item.comingSoon
				? `${item.label}. ${this.$t('myArea.menu.comingSoon')}`
				: item.label
		},
		scrollActiveItemIntoView(smooth = true) {
			this.$nextTick(() => {
				const item = this.$el.querySelector(`.profile-menu__item[data-qa-id="${this.activeItem}"]`)
				if (!item) return

				const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
				const left = item.offsetLeft - ((this.$el.clientWidth - item.offsetWidth) / 2)

				this.$el.scrollTo({
					left: Math.max(0, left),
					behavior: smooth && !prefersReducedMotion ? 'smooth' : 'auto'
				})
			})
		}
	}
}
</script>

<template>
	<nav class="profile-menu" data-qa="profile-navigation-menu" :aria-label="$t('myArea.menu.ariaLabel')">
		<ul class="profile-menu__list" data-qa="profile-navigation-list">
			<li
				v-for="item in items"
				:key="item.id"
				class="profile-menu__item"
				data-qa="profile-navigation-item"
				:data-qa-id="item.id"
			>
				<AppButton
					data-qa="profile-navigation-tab-item"
					:data-qa-id="item.id"
					variant="profile-tab"
					:icon="item.icon"
					:active="activeItem === item.id"
					:disabled="!item.available"
					:aria-label="getAccessibilityLabel(item)"
					:title="item.comingSoon ? $t('myArea.menu.comingSoon') : undefined"
					@click="$emit('select', item.id)"
				>
					{{ item.label }}
					<small v-if="item.comingSoon" class="profile-menu__coming-soon">{{ $t('myArea.menu.comingSoon') }}</small>
				</AppButton>
			</li>
		</ul>
	</nav>
</template>

<style lang="sass" scoped>
@use '../../assets/sass/utilities/_responsive' as *

.profile-menu
	width: 100%
	overflow-x: auto
	scroll-behavior: smooth
	scroll-snap-type: x proximity
	scrollbar-width: thin
	margin-top: 1rem

	&__list
		display: flex
		align-items: center
		gap: 0.5rem
		width: max-content
		min-width: 100%
		list-style: none
		justify-content: flex-start
		+respond-to($breakpoint-lg-min)
			gap: 0.5rem
			justify-content: center

	&__item
		flex: 0 0 auto
		scroll-snap-align: center

	&__coming-soon
		padding: 0.125rem 0.375rem
		border-radius: 999px
		background-color: var(--lg-light-gray-300)
		color: var(--lg-mid-gray-200)
		font-family: var(--lgei-text)
		font-size: 0.625rem
		font-weight: 600
		line-height: 1

	:deep(.AppButton i)
		display: inline-flex
		width: 1.5rem
		height: 1.5rem
		flex: 0 0 1.5rem

@media (prefers-reduced-motion: reduce)
	.profile-menu
		scroll-behavior: auto
</style>
